import config from '../config';


export async function fetchCommissioningProcedureData(backendFetch, siteId) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/commissioning-procedure/" + siteId)
    return await f.json()
}

export async function fetchCommissioningProcedureDevice(backendFetch, siteId, deviceDbId, phaseKey) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/commissioning-procedure/phase/device/" + siteId + "/" + phaseKey + "/"+ deviceDbId)
    return await f.json()
}

export async function fetchFinalVerificationStep(backendFetch, siteId, finalVerificationStepId) {
    const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/commissioning-procedure/phase/final-verification-step/" + siteId + "/" + finalVerificationStepId)
    return await f.json()
}

export async function addVerificationComments(backendFetch, siteId, finalVerificationStepId, comments) {
    const formData = new FormData();
    formData.append('comments', comments);
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/log-comments/' + siteId + "/" + finalVerificationStepId, {
        method: 'POST',
        body: formData,
    });
}

export async function startResetCommissioningProcedure(backendFetch, siteId, action_type) {
    const formData = new FormData();
    formData.append('action', action_type);
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/actions/' + siteId, {
        method: 'PUT',
        body: formData,
    });
}

export async function hardResetProcedure(backendFetch, siteId) {
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/hard-reset/' + siteId, {
        method: 'PUT',
        body: {},
    });
}

export async function updateCommissiongProcedureDeviceStep(backendFetch, siteId, step_id, step_value, warnings) {
    const formData = new FormData();
    formData.append('step_value', step_value);
    formData.append('warnings', warnings)
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/'+ siteId + '/device-step/' + step_id, {
        method: 'PUT',
        body: formData,
    });
}

export async function updateCommissiongProcedureFinalVerficationStep(backendFetch, siteId, step_id, step_value, action, deny_reason=null) {
    const formData = new FormData();
    formData.append('step_value', step_value);
    formData.append('action', action)
    formData.append("deny_reason", deny_reason)
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/'+ siteId + '/verification-step/' + step_id, {
        method: 'PUT',
        body: formData,
    });
}

export async function updateCommissiongProcedureAcceptUserAgreement(backendFetch, siteId, step_id) {
    const formData = new FormData();
    formData.append('step_value', true);
    await backendFetch(config.REACT_APP_HOST + '/api/v2/commissioning-procedure/'+ siteId + '/accept-user-agreement/' + step_id, {
        method: 'PUT',
        body: formData,
    });
}